import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/types/general';
import { Location } from '../types';
import { warehouseService } from 'features/inventory/warehouses/api/warehouse.service';

interface LocationFormProps {
  location: Location;
  onSubmit: (data: Partial<Location>) => void;
  disableEdit?: boolean;
}

function LocationForm({ location, onSubmit, disableEdit }: LocationFormProps) {
  const { t } = useTranslation();

  const [warehouses, setWarehouses] = useState<Option[]>([]);

  useEffect(() => {
    warehouseService.getAllBaseInformation().then(setWarehouses);
  }, []);

  return (
    <div>
      {location && (
        <EnhancedForm
          onSubmit={disableEdit ? {} : onSubmit}
          edit={!!location.id}
          disableEdit={disableEdit}
          autoStyleLayout={true}
          columns={5}>
          <IdentityField
            gridSpan={2}
            name="code"
            initialValue={location.code}
            component={TextFieldAdapter}
            label={t('global.code')}
            type="text"
            validate={required}
            disabled={disableEdit}
          />
          <IdentityField
            gridSpan={3}
            name="description"
            initialValue={location.description}
            component={TextFieldAdapter}
            label={t('global.description')}
            type="text"
            validate={required}
            disabled={disableEdit}
          />
          {!location.warehouse && warehouses.length > 0 && (
            <IdentityField
              gridSpan={5}
              name="warehouse"
              component={AutocompleteAdapter}
              options={warehouses}
              initValue={warehouses.find((warehouse) => warehouse.code === location.warehouse)}
              label={t('global.warehouse')}
              type="text"
              disabled={disableEdit}
            />
          )}
        </EnhancedForm>
      )}
    </div>
  );
}

export default LocationForm;
